export default "__VITE_ASSET__2bAw9Z9L__"